import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { recognizeItems } from '../data/matematik';
export function Recognize() {
  return <section className="w-full bg-slate-900 px-8 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-265" data-mp="30xq4jav4cet7">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12" data-id="element-266" data-mp="2w56q6bolxfnc">
        <div className="self-start lg:sticky lg:top-24 lg:col-span-5" data-id="element-267" data-mp="2r7wre5fbvrmu">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-268" data-mp="2m8bus1nmrvda">
            Har du nogensinde oplevet det her?
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-269" data-mp="2i5x979skuhib">
            Hvis du svarer ja til bare ét af spørgsmålene, er MATEMATIK KLAR™ lavet til dig.
          </p>
          <a href="#inside" className="group mt-10 inline-flex items-center gap-2 font-serif text-2xl italic text-red-300 transition-colors duration-150 ease-out hover:text-stone-50" data-id="element-270" data-mp="289kjso42eptd">
            Du fortjener en lettere vej
            <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-271" data-mp="6hz2075z5cm4" />
          </a>
        </div>

        <ul className="divide-y divide-white/10 border-y border-white/10 lg:col-span-7" data-id="element-272" data-mp="3nmxfyx8ggpgl">
          {recognizeItems.map(item => {
          const Icon = item.icon;
          return <li key={item.title} className="flex gap-5 py-7 sm:gap-6" data-id="element-273" data-mp="3elqz2n1w9cmt">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-white/15 text-red-300" data-id="element-274" data-mp="3eo3g8xztviyt">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-275" data-mp="b5s7453v8enn" />
                </span>
                <div data-id="element-276" data-mp="3sm1pxq37er7z">
                  <h3 className="font-serif text-2xl leading-tight sm:text-3xl" data-id="element-277" data-mp="3smjv5c7ugfs1">{item.title}</h3>
                  <p className="mt-2 leading-relaxed text-stone-50/70" data-id="element-278" data-mp="1ep6f4eum1ow">{item.text}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}